<template>
  <v-card
    class="mx-auto mb-3"
    max-width="600"
    :loading="loading"
    :disabled="loading"
    v-if="is_officer"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1 class="pa-0">
          เรียกดู สจล.1 (อ่านอย่างเดียว) (รหัส 63xxxxxx ขึ้นไป)
        </h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-form ref="form" v-model="validSurrogatedStudentId" @submit.prevent="">
      <v-card-text>
        <v-text-field
          label="รหัสนักศึกษา (รหัส 63xxxxxx ขึ้นไป)"
          v-model="inputSurrogatedStudentId"
          type="text"
          :rules="surrogetedStudentIdRules"
          required
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="d-flex justify-center pb-3">
        <v-btn
          type="submit"
          color="primary"
          variant="flat"
          elevation="2"
          :disabled="!validSurrogatedStudentId"
          @click="loginSurrogatedStudentId"
          >Login</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>

  <div v-if="surrogated_student_info">
    <v-card v-if="!is_completed">
      <h1 class="text-center text-error my-16">
        {{ $t("kmitl1.not_complete") }}
      </h1>
    </v-card>
    <v-card max-width="1000" class="pa-0 mx-auto" :key="rand" v-else>
      <v-card-title class="pa-0 mt-5">
        <v-row align="center" justify="center">
          <v-col>
            <v-img
              class="float-right"
              width="150"
              src="images/Main_Logo_KMITL_Thai_Orange.png"
            ></v-img>
          </v-col>
          <v-col>
            <h1 class="text-primary title">
              {{ $t("kmitl1.title") }}
            </h1>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text
        class="pa-0 pa-sm-2 pa-md-3 pa-lg-4 pa-xl-4 mt-3 mt-sm-0 mt-sm-0"
      >
        <SectionOne />
        <v-card max-width="1000" class="rounded-0 mx-auto">
          <v-toolbar color="#A0522D" id="section-8">
            <v-toolbar-title>
              <h1>{{ $t("info_card.title_page8") }}</h1>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="px-0 px-md-3 px-xl-6">
            <SectionTwo />
          </v-card-text>
        </v-card>
        <SectionThree />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SectionOne from "@/components/sections/Section1.vue";
import SectionTwo from "@/components/sections/Section2.vue";
import SectionThree from "@/components/sections/Section3.vue";

import UserProvider from "@/services/user.provider.js";
const userProvider = new UserProvider();

export default {
  name: "KmitlOne",

  components: {
    SectionOne,
    SectionTwo,
    SectionThree,
  },

  data: () => ({
    loading: false,
    rand: null,

    validSurrogatedStudentId: false,
    inputSurrogatedStudentId: "",
    surrogetedStudentIdRules: [
      (v) => !!v || "Student ID is required",
      (v) => v.length == 8 || "Student ID must be 8 digits",
      (v) => /^\d+$/.test(v) || "Student ID must be valid",
    ],
  }),

  computed: {
    is_officer() {
      return this.$store.state.user.is_officer;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    is_completed() {
      if (
        this.surrogated_student_info &&
        this.surrogated_student_info.MATRICULATION_STATUS_ID == "3"
      )
        return true;
      else return false;
    },
  },

  methods: {
    async loginSurrogatedStudentId() {
      this.loading = true;
      sessionStorage.setItem(
        "surrogated_student_id",
        this.inputSurrogatedStudentId
      );

      await userProvider
        .logAccessKmitl1(this.inputSurrogatedStudentId)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });

      await this.$store.dispatch("user/getUserInfo");
      if (this.surrogated_student_info) {
        this.rand = Math.random();
      } else {
        sessionStorage.removeItem("surrogated_student_id");
      }
      this.loading = false;
    },
  },

  created() {
    if (this.$route.query.student_id) {
      this.inputSurrogatedStudentId = this.$route.query.student_id;
      this.loginSurrogatedStudentId();
    }
  },
};
</script>

<style scoped>
.title {
  font-size: 50px !important;
}
</style>
